module.exports = "<div class=\"page-header\">\n    <h1>Configuración</h1>\n</div>\n<div class=\"row\">\n    <div class=\"col\">\n    </div>\n</div>"